import { Field, Form, Formik } from 'formik';
import { FormikModalT } from '../types';
import { Button } from '../../../components';
import { useTranslation } from 'react-i18next';

import styles from '../Fleet.module.scss';

export const AddModal = ({ initialInputValue, modalValidationSchema, handleSubmit, handleCloseModal }: FormikModalT) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialInputValue}
      onSubmit={(values, { resetForm }) => {
        handleSubmit(values);
        resetForm();
      }}
      validateOnChange
      validationSchema={modalValidationSchema}
    >
      {({ errors, values }) => {
        return (
          <Form>
            <label className={styles.modal_label} htmlFor="mmsi">
              {t('ModalAddToFleetLabel')}
              <Field
                id="mmsi"
                className={styles.modal_input}
                name="mmsi"
                placeholder={t('FieldPlaceholderMMSI')}
                type="string"
                autoComplete="off"
              />
            </label>
            <div className={styles.buttons_group}>
              <Button
                variant="primary"
                label={t('ButtonLabelAdd')}
                type="submit"
                disabled={values.mmsi.length < 9 || errors.mmsi ? true : false}
              />

              <Button variant="general" label={t('ButtonLabelToDiscard')} type="reset" onClick={handleCloseModal} />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
